// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._13qblvt0 {
  min-width: var(--_18w76bw1x);
  text-decoration: underline;
  margin-top: var(--_18w76bwc);
  font-weight: var(--_18w76bw3z);
}
@media screen and (max-width: 768px) {
  ._13qblvt0 {
    min-width: var(--_18w76bw1w);
    margin-top: var(--_18w76bw9);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE;IACE,4BAA4B;IAC5B,4BAA4B;EAC9B;AACF","sourcesContent":["._13qblvt0 {\n  min-width: var(--_18w76bw1x);\n  text-decoration: underline;\n  margin-top: var(--_18w76bwc);\n  font-weight: var(--_18w76bw3z);\n}\n@media screen and (max-width: 768px) {\n  ._13qblvt0 {\n    min-width: var(--_18w76bw1w);\n    margin-top: var(--_18w76bw9);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
